import { React, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaRegTrashAlt } from "react-icons/fa";

export default function ProductB({
  items,
  handleDeleteProduct,
  onUploadSuccess,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [deletingId, setDeletingId] = useState(null);
  const [removingId, setRemovingId] = useState(null);
  const itemsPerPage = 10;
  const handleNextPage = () => {
    const totalPages = Math.ceil(items.length / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleDelete = async (item) => {
    setDeletingId(item.itemid); // disable delete button
    setRemovingId(item.itemid); // start fade-out animation

    try {
      await handleDeleteProduct(item); // call parent delete logic
    } catch (err) {
      console.error("Delete error:", err);
      setRemovingId(null); // reset if failed
      setDeletingId(null);
      return;
    }

    // Delay removal so animation can finish
    setTimeout(() => {
      setRemovingId(null);
      setDeletingId(null);
      onUploadSuccess(); // refresh list or remove item locally
    }, 500); // must match CSS transition time
  };

  return (
    <>
      <h4 className="text-center" style={{ marginTop: "30px" }}>
        Recently Generated iSheets (Product B)
      </h4>
      <div className="table-responsive">
        <table
          className="table table-bordered border-primary"
          style={{ border: "1px solid red", fontSize: "14px" }}
        >
          <thead>
            <tr>
              <th style={{ border: "1px solid green", fontWeight: "bold" }}>
                #
              </th>
              <th style={{ border: "1px solid green", fontWeight: "bold" }}>
                Riverchain ID
              </th>
              <th style={{ border: "1px solid green", fontWeight: "bold" }}>
                Borrower's name(English)
              </th>
              <th style={{ border: "1px solid green", fontWeight: "bold" }}>
                Created date
              </th>
              <th style={{ border: "1px solid green", fontWeight: "bold" }}>
                Created by
              </th>
              <th style={{ border: "1px solid green", fontWeight: "bold" }}>
                Modified by
              </th>
              <th style={{ border: "1px solid green", fontWeight: "bold" }}>
                Version
              </th>
              <th style={{ border: "1px solid green", fontWeight: "bold" }}>
                Delete
              </th>
            </tr>
          </thead>
          <tbody>
            {items && items.length > 0 ? (
              [...items]
                .sort((a, b) => {
                  const createdA = a.column.find((col) =>
                    ["2719", "2001"].includes(col.attributecolumnid)
                  )?.displaydata?.value;

                  const createdB = b.column.find((col) =>
                    ["2719", "2001"].includes(col.attributecolumnid)
                  )?.displaydata?.value;

                  const dateA = createdA ? new Date(createdA) : new Date(0);
                  const dateB = createdB ? new Date(createdB) : new Date(0);

                  return dateB - dateA; // DESCENDING → newest first
                })
                .slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )
                .map((item, index) => (
                  <tr
                    key={item.itemid}
                    className={`fade-out ${
                      removingId === item.itemid ? "removing" : ""
                    }`}
                  >
                    {/* Serial Number */}
                    <td
                      style={{
                        border: "1px solid green",
                        fontWeight: "bold",
                      }}
                    >
                      {index + 1}
                    </td>

                    {/* Riverchain ID */}
                    {(() => {
                      const firstColumn = item.column.find(
                        (col) =>
                          col.attributecolumnid === "2720" ||
                          col.attributecolumnid === "745"
                      );
                      return firstColumn ? (
                        <td style={{ border: "1px solid green" }}>
                          {firstColumn.displaydata?.value || "--"}
                        </td>
                      ) : null;
                    })()}

                    {(() => {
                      const firstColumn = item.column.find(
                        (col) =>
                          col.attributecolumnid === "2721" ||
                          col.attributecolumnid === "746"
                      );
                      return firstColumn ? (
                        <td style={{ border: "1px solid green" }}>
                          {firstColumn.displaydata?.value || "--"}
                        </td>
                      ) : null;
                    })()}

                    {/* Created Date */}
                    {(() => {
                      const firstColumn = item.column.find(
                        (col) =>
                          col.attributecolumnid === "2719" ||
                          col.attributecolumnid === "744"
                      );
                      return firstColumn ? (
                        <td style={{ border: "1px solid green" }}>
                          {firstColumn.displaydata?.value || "--"}
                        </td>
                      ) : null;
                    })()}

                    {(() => {
                      const firstColumn = item.column.find(
                        (col) =>
                          col.attributecolumnid === "2718" ||
                          col.attributecolumnid === "743"
                      );
                      return firstColumn ? (
                        <td style={{ border: "1px solid green" }}>
                          {firstColumn.displaydata?.lookupusers?.lookupuser
                            ?.userdisplayname || "--"}
                        </td>
                      ) : null;
                    })()}

                    {/* Display other columns */}
                    {item.column
                      .filter((col) => col.attributecolumnid !== "2719")
                      .slice(0, 1)
                      .map((col, colIndex) => (
                        <td
                          key={colIndex}
                          style={{ border: "1px solid green" }}
                        >
                          {col.rawdata?.value
                            ? col.rawdata.value
                            : col.displaydata?.lookupusers?.lookupuser
                                ?.userdisplayname
                            ? String(
                                col.displaydata.lookupusers.lookupuser
                                  .userdisplayname
                              )
                            : col.rawdata?.time
                            ? col.rawdata.time
                            : col.displaydata?.value
                            ? col.displaydata.value
                            : "--"}
                        </td>
                      ))}

                    <td style={{ border: "1px solid green" }}>
                      {item.version}
                    </td>

                    {/* Delete Button */}
                    <td style={{ textAlign: "center" }}>
                      <button
                        onClick={() => handleDelete(item)}
                        disabled={deletingId === item.itemid}
                        style={{
                          backgroundColor:
                            deletingId === item.itemid ? "gray" : "red",
                          color: "white",
                          border: "none",
                          padding: "5px 10px",
                          cursor:
                            deletingId === item.itemid
                              ? "not-allowed"
                              : "pointer",
                          borderRadius: "5px",
                        }}
                      >
                        {deletingId === item.itemid ? (
                          "Deleting..."
                        ) : (
                          <>
                            <FaRegTrashAlt /> Delete
                          </>
                        )}
                      </button>
                    </td>
                  </tr>
                ))
            ) : (
              <tr styele={{ textAlign: "center" }}>
                <td colSpan="7">Data is loading...</td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="d-flex justify-content-between align-items-center mt-3">
          <button
            className="btn btn-outline-primary"
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span>Page {currentPage}</span>
          <button
            className="btn btn-outline-primary"
            onClick={handleNextPage}
            disabled={
              currentPage === Math.ceil((items?.length || 0) / itemsPerPage)
            }
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
}
